import React, { useState } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, MenuItem, Tabs, Tab, InputAdornment, Dialog,
    DialogTitle, DialogContent, DialogActions, Avatar, LinearProgress
} from '@mui/material';
import {
    Search as SearchIcon, Add as AddIcon, Download as DownloadIcon,
    Phone as PhoneIcon, Email as EmailIcon, School as SchoolIcon,
    CheckCircle as CheckIcon, Schedule as PendingIcon,
    TrendingUp as TrendingUpIcon, PersonAdd as PersonAddIcon
} from '@mui/icons-material';
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { toast } from 'react-toastify';

const EnquiryDashboard = () => {
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [formData, setFormData] = useState({ studentName: '', parentName: '', phone: '', email: '', class: '', source: '', notes: '' });

    const enquiries = [
        { id: 1, studentName: 'Arjun Mehta', parentName: 'Suresh Mehta', phone: '9876543210', email: 'suresh@email.com', class: 'Class 1', source: 'Walk-in', date: '2026-02-15', status: 'New', followDate: '2026-02-18', notes: 'Interested in admission for next year' },
        { id: 2, studentName: 'Kavya Joshi', parentName: 'Ramesh Joshi', phone: '9876543211', email: 'ramesh@email.com', class: 'LKG', source: 'Phone', date: '2026-02-14', status: 'Follow Up', followDate: '2026-02-17', notes: 'Asked about fee structure' },
        { id: 3, studentName: 'Siddharth Patil', parentName: 'Anil Patil', phone: '9876543212', email: 'anil@email.com', class: 'Class 5', source: 'Website', date: '2026-02-13', status: 'Converted', followDate: '-', notes: 'Admitted' },
        { id: 4, studentName: 'Riya Shah', parentName: 'Nitin Shah', phone: '9876543213', email: 'nitin@email.com', class: 'UKG', source: 'Referral', date: '2026-02-12', status: 'Follow Up', followDate: '2026-02-16', notes: 'Referred by Patil family' },
        { id: 5, studentName: 'Vivaan Kulkarni', parentName: 'Manoj Kulkarni', phone: '9876543214', email: 'manoj@email.com', class: 'Class 3', source: 'Walk-in', date: '2026-02-10', status: 'Lost', followDate: '-', notes: 'Chose other school' },
        { id: 6, studentName: 'Aarya Desai', parentName: 'Vikram Desai', phone: '9876543215', email: 'vikram@email.com', class: 'Class 8', source: 'Phone', date: '2026-02-08', status: 'New', followDate: '2026-02-19', notes: 'Transfer from Pune' },
    ];

    const filteredData = enquiries.filter(e => {
        const matchTab = tab === 0 ? true : tab === 1 ? e.status === 'New' : tab === 2 ? e.status === 'Follow Up' : tab === 3 ? e.status === 'Converted' : e.status === 'Lost';
        const matchSearch = !searchTerm || e.studentName.toLowerCase().includes(searchTerm.toLowerCase()) || e.parentName.toLowerCase().includes(searchTerm.toLowerCase());
        return matchTab && matchSearch;
    });

    const newCount = enquiries.filter(e => e.status === 'New').length;
    const followUpCount = enquiries.filter(e => e.status === 'Follow Up').length;
    const convertedCount = enquiries.filter(e => e.status === 'Converted').length;
    const lostCount = enquiries.filter(e => e.status === 'Lost').length;
    const conversionRate = Math.round((convertedCount / enquiries.length) * 100);

    const sourceChart = {
        labels: ['Walk-in', 'Phone', 'Website', 'Referral'],
        datasets: [{ data: [2, 2, 1, 1], backgroundColor: ['#1a9e8f', '#2196f3', '#ff9800', '#e91e63'], borderWidth: 0 }],
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonAddIcon sx={{ color: '#1a9e8f', fontSize: 28 }} />
                    <Typography variant="h5" fontWeight={700}>Enquiry Dashboard</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="contained" startIcon={<AddIcon />} size="small" onClick={() => setOpenDialog(true)}>New Enquiry</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Export</Button>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} sm={2.4}>
                    <Card><CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                        <Typography variant="body2" color="text.secondary">Total</Typography>
                        <Typography variant="h4" fontWeight={700}>{enquiries.length}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={2.4}>
                    <Card sx={{ borderLeft: '4px solid #2196f3' }}><CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                        <Typography variant="body2" color="text.secondary">New</Typography>
                        <Typography variant="h4" fontWeight={700} color="primary.main">{newCount}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={2.4}>
                    <Card sx={{ borderLeft: '4px solid #ff9800' }}><CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                        <Typography variant="body2" color="text.secondary">Follow Up</Typography>
                        <Typography variant="h4" fontWeight={700} color="warning.main">{followUpCount}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={6} sm={2.4}>
                    <Card sx={{ borderLeft: '4px solid #4caf50' }}><CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                        <Typography variant="body2" color="text.secondary">Converted</Typography>
                        <Typography variant="h4" fontWeight={700} color="success.main">{convertedCount}</Typography>
                    </CardContent></Card>
                </Grid>
                <Grid item xs={12} sm={2.4}>
                    <Card sx={{ borderLeft: '4px solid #1a9e8f' }}><CardContent sx={{ textAlign: 'center', py: 1.5 }}>
                        <Typography variant="body2" color="text.secondary">Conversion</Typography>
                        <Typography variant="h4" fontWeight={700}>{conversionRate}%</Typography>
                        <LinearProgress variant="determinate" value={conversionRate}
                            sx={{ mt: 0.5, height: 4, borderRadius: 2 }} />
                    </CardContent></Card>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={8}>
                    <Card>
                        <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                            <Tab label={`All (${enquiries.length})`} />
                            <Tab label={`New (${newCount})`} />
                            <Tab label={`Follow Up (${followUpCount})`} />
                            <Tab label={`Converted (${convertedCount})`} />
                            <Tab label={`Lost (${lostCount})`} />
                        </Tabs>
                        <Box sx={{ p: 2 }}>
                            <TextField fullWidth size="small" placeholder="Search by name..." value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} sx={{ mb: 1.5 }}
                                InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                            <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Parent</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Class</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Source</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Follow Up</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredData.map(e => (
                                            <TableRow key={e.id} hover>
                                                <TableCell sx={{ fontWeight: 600 }}>{e.studentName}</TableCell>
                                                <TableCell>{e.parentName}</TableCell>
                                                <TableCell>{e.class}</TableCell>
                                                <TableCell><Chip label={e.source} size="small" variant="outlined" /></TableCell>
                                                <TableCell>{new Date(e.date).toLocaleDateString()}</TableCell>
                                                <TableCell>{e.followDate !== '-' ? new Date(e.followDate).toLocaleDateString() : '-'}</TableCell>
                                                <TableCell>
                                                    <Chip size="small" label={e.status}
                                                        color={e.status === 'Converted' ? 'success' : e.status === 'Lost' ? 'error' : e.status === 'New' ? 'primary' : 'warning'} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ height: '100%' }}>
                        <CardContent>
                            <Typography variant="subtitle2" fontWeight={700} gutterBottom>Enquiry Sources</Typography>
                            <Box sx={{ maxWidth: 180, mx: 'auto' }}>
                                <Doughnut data={sourceChart} options={{ plugins: { legend: { position: 'bottom' } }, cutout: '60%' }} />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>New Enquiry</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField label="Student Name" fullWidth value={formData.studentName} onChange={(e) => setFormData({ ...formData, studentName: e.target.value })} />
                        <TextField label="Parent Name" fullWidth value={formData.parentName} onChange={(e) => setFormData({ ...formData, parentName: e.target.value })} />
                        <Grid container spacing={2}>
                            <Grid item xs={6}><TextField label="Phone" fullWidth value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} /></Grid>
                            <Grid item xs={6}><TextField label="Email" fullWidth value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} /></Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField select label="Class" fullWidth value={formData.class} onChange={(e) => setFormData({ ...formData, class: e.target.value })}>
                                    {['Nursery', 'LKG', 'UKG', 'Class 1', 'Class 2', 'Class 3', 'Class 5', 'Class 8'].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField select label="Source" fullWidth value={formData.source} onChange={(e) => setFormData({ ...formData, source: e.target.value })}>
                                    {['Walk-in', 'Phone', 'Website', 'Referral', 'Social Media', 'Other'].map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                                </TextField>
                            </Grid>
                        </Grid>
                        <TextField label="Notes" fullWidth multiline rows={2} value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={() => { toast.success('Enquiry saved'); setOpenDialog(false); }}>Save Enquiry</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default EnquiryDashboard;
